import { createStore } from 'stimulus-store';

export const modelStore = createStore({
    name: 'modelStore',
    type: Object,
    initialValue: {}
});